<template>
  <div class="confirmation-container">
    <v-dialog
      v-for="dialog of dialogs"
      :key="dialog.id"
      v-model="dialog.model"
      :width="dialog.width"
      persistent
    >
      <Modal
        :id="dialog.id + ' cmp-confirmation-modal'"
        :optionsJustify="dialog.optionsJustify"
        @cancelled="dialog.complete('Cancel')"
      :class="{
        'noheader': !dialog.subject
      }"
      >
        <template slot="header">
          <div
            style="
              margin: 0 0 0px;
              color: var(--text-accent);
              text-transform: uppercase;
              font-size: 15px;
              text-align: left;
              margin-left: 2px;
            "
            :class="dialog.subjectClass"
          >
            {{ dialog.subject }}
          </div>
        </template>

        <template slot="body">
          <div style="margin-left: 2px" v-html="dialog.body"></div>
        </template>

        <template slot="options">
          <button
            class="dt-button s6"
            :class="result.classes"
            v-for="result of dialog.results"
            :key="result.value"
            @click="dialog.complete(result.value)"
          >
            {{ result.text }}
          </button>
        </template>
      </Modal>
    </v-dialog>
  </div>
</template>

<script>
import Modal from "../modal/modal";

import { ConfirmationService } from "./confirmation.service";

export default {
  components: {
    Modal,
  },
  mounted: function () {
    ConfirmationService.onConfirmationChanged((res) => {
      this.dialogs = res;
    });

    // setTimeout(() => {
    //   ConfirmationService.create({
    //     subject: 'Are you sure you want to continue ?',
    //     model: true,
    //     width: 500,
    //     completed: res => {
    //       console.log('Modal Completed', res);
    //     }
    //   });
    // }, 0)
  },
  data: function () {
    return {
      dialogs: [],
    };
  },
};
</script>

<style  lang="scss">
.cmp-confirmation-modal {
  .dt-modal--header {
    margin-bottom: 20px !important;
  }
  &.noheader {
    .dt-modal--header {
      display: none;
    }
    .dt-modal--body {
      margin-top: 20px;
    }
  }
  .dt-modal--header {
    text-align: center;
    text-transform: none;
    margin: 0px 0 0px;
    color: rgba(0, 0, 0, 0.87);
  }

  .dt-modal--body {
    // padding-top: 20px;
    overflow: hidden;
  }

  .dt-modal--options {
    display: flex;
    justify-content: center !important;

    .dt-button {
      --btn-margin: 0px;
      min-width: 140px;
      max-width: fit-content;
    }
  }
}
</style>
